export { default as Cookies } from 'js-cookie';

function run() {
    return {
        language: navigator.language.toLowerCase(),
        version: (function () {
            var u = navigator.userAgent;
            var kuleWebview = u.match(/KuleWebview\/([\d.]+)/);
            return {
                mobile: !!u.match(/AppleWebKit.*Mobile.*/) ||
                    (!!u.match(/AppleWebKit/) && u.indexOf('QIHU') && u.indexOf('QIHU') > -1 && u.indexOf('Chrome') < 0),
                android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
                iPad: u.indexOf('iPad') > -1,
                kuleWebview: !!kuleWebview,
                sdkVersion: kuleWebview && kuleWebview.length > 1 ? kuleWebview[1] : null
            };
        })()
    };
}
var browser = /* #__PURE__ */ run();

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var CustomError = /*#__PURE__ */ (function (_super) {
    __extends(CustomError, _super);
    function CustomError(config) {
        var _this = this;
        var code = config.code, _a = config.message, message = _a === void 0 ? '' : _a, _b = config.payload, payload = _b === void 0 ? {} : _b;
        _this = _super.call(this, message) || this;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, CustomError);
        }
        Object.setPrototypeOf(_this, CustomError.prototype);
        _this.code = code || 'UNKNOWN_ERROR';
        _this.payload = payload;
        var errorPayload = payload;
        if (errorPayload && errorPayload.stateCode) {
            if (errorPayload.stateCode === -1) {
                _this.code = 'AUTH_INVALID';
                _this.message = 'Authoriztion Invalid';
            }
            if (errorPayload.stateCode === -5) {
                _this.code = 'SERVER_ERROR';
                _this.message = 'Server Error';
            }
        }
        _this.name = 'TGA PLATFORM | ' + _this.code;
        return _this;
    }
    CustomError.throwError = function (error) {
        throw error instanceof Error ? error : new CustomError(error);
    };
    return CustomError;
}(Error));

var EventBus = /*#__PURE__ */ (function () {
    function EventBus() {
    }
    EventBus.addEventListener = function (eventName, callback, scope) {
        if (scope === void 0) { scope = null; }
        var handlers = this.listeners[eventName] || [];
        handlers.push({
            scope: scope,
            callback: callback
        });
        this.listeners[eventName] = handlers;
    };
    EventBus.removeEventListener = function (eventName, callback, scope) {
        if (scope === void 0) { scope = null; }
        var handlers = this.listeners[eventName] || [];
        var newHandlers = [];
        if (callback) {
            newHandlers = handlers.filter(function (handler) {
                return handler.callback !== callback && handler.scope === scope;
            });
        }
        this.listeners[eventName] = newHandlers;
    };
    EventBus.hasEventListener = function (eventName, callback, scope) {
        if (scope === void 0) { scope = null; }
        var handlers = this.listeners[eventName] || [];
        if (!callback && scope === null) {
            return handlers.length > 0;
        }
        var handlersFiltered = handlers.filter(function (handler) {
            return handler.callback !== callback && handler.scope === scope;
        });
        return handlersFiltered.length > 0;
    };
    EventBus.dispatch = function (eventName) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var handlers = (this.listeners[eventName] || []).slice();
        handlers.forEach(function (handler) {
            var callback = handler.callback, scope = handler.scope;
            callback.apply(scope, args);
        });
    };
    EventBus.listeners = {};
    return EventBus;
}());

/**
 * 动态加载script
 * @param url 加载JS的地址
 * @param params JS带的参数
 * @returns 是否加载成功
 */
function loadScript(url, params) {
    if (params === void 0) { params = {}; }
    return new Promise(function (resolve, reject) {
        var _a;
        var script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        Object.keys(params).forEach(function (key) {
            var value = params[key];
            var valueType = Object.prototype.toString.call(value);
            if (valueType === '[object String]' || valueType === '[object Number]') {
                script.setAttribute(key, value);
            }
        });
        script.onload = function () {
            resolve(true);
        };
        script.onerror = function (error) {
            reject(error);
        };
        script.setAttribute('src', url);
        (_a = document.getElementsByTagName('head')[0]) === null || _a === void 0 ? void 0 : _a.appendChild(script);
    });
}

var LocalStorage = /*#__PURE__ */ (function () {
    function LocalStorage() {
    }
    LocalStorage.clear = function () {
        return this.store.clear();
    };
    LocalStorage.getItem = function (key) {
        var value = this.store.getItem(key);
        if (value === null) {
            return null;
        }
        try {
            return JSON.parse(value);
        }
        catch (error) {
            return value;
        }
    };
    LocalStorage.setItem = function (key, value) {
        try {
            this.store.setItem(key, JSON.stringify(value));
        }
        catch (error) {
            this.store.setItem(key, value);
        }
    };
    LocalStorage.getItemExpire = function (key) {
        var value = this.store.getItem(key);
        if (value === null) {
            return null;
        }
        try {
            var data = JSON.parse(value);
            if (!data.expireAt) {
                return JSON.parse(value);
            }
            if (data.expireAt < Date.now()) {
                this.removeItem(key);
                return null;
            }
            return data.data;
        }
        catch (error) {
            return null;
        }
    };
    LocalStorage.setItemExpire = function (key, value, expireTime) {
        var data = {
            data: value,
            expireAt: Date.now() + expireTime * 1000
        };
        this.store.setItem(key, JSON.stringify(data));
    };
    LocalStorage.removeItem = function (key) {
        return this.store.removeItem(key);
    };
    LocalStorage.key = function (index) {
        return this.store.key(index);
    };
    LocalStorage.store = window.localStorage;
    return LocalStorage;
}());

var Logger = /*#__PURE__ */ (function () {
    function Logger(prefix, level) {
        if (prefix === void 0) { prefix = 'unknown'; }
        if (level === void 0) { level = Logger.LEVEL.DEBUG; }
        this.prefix = prefix;
        this.level = level;
    }
    /**
     * 打印错误日志
     * @param optionalParams 日志参数
     */
    Logger.prototype.error = function (message) {
        if (message === void 0) { message = ''; }
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (this.isLevelVisible(Logger.LEVEL.ERROR)) {
            console.error.apply(null, ["".concat(this.getRealPrefix(), " ").concat(message)].concat(optionalParams));
        }
    };
    /**
     * 打印警告日志
     * @param optionalParams 日志参数
     */
    Logger.prototype.warn = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (this.isLevelVisible(Logger.LEVEL.WARN)) {
            console.warn.apply(null, ["".concat(this.getRealPrefix(), " ").concat(message)].concat(optionalParams));
        }
    };
    /**
     * 打印普通日志
     * @param optionalParams 日志参数
     */
    Logger.prototype.info = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (this.isLevelVisible(Logger.LEVEL.INFO)) {
            console.info.apply(null, ["".concat(this.getRealPrefix(), " ").concat(message)].concat(optionalParams));
        }
    };
    /**
     * 打印普通日志
     * @param optionalParams 日志参数
     */
    Logger.prototype.log = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (this.isLevelVisible(Logger.LEVEL.INFO)) {
            console.log.apply(null, ["".concat(this.getRealPrefix(), " ").concat(message)].concat(optionalParams));
        }
    };
    /**
     * 打印debug日志
     * @param optionalParams 日志参数
     */
    Logger.prototype.debug = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (this.isLevelVisible(Logger.LEVEL.DEBUG)) {
            console.debug.apply(null, ["".concat(this.getRealPrefix(), " ").concat(message)].concat(optionalParams));
        }
    };
    Logger.prototype.getRealPrefix = function () {
        return "[".concat(this.prefix, "]");
    };
    Logger.prototype.isLevelVisible = function (level) {
        return level <= this.level;
    };
    Logger.LEVEL = {
        NONE: 0,
        ERROR: 1,
        WARN: 2,
        INFO: 3,
        DEBUG: 4
    };
    return Logger;
}());

// 日志前缀
var LOGGER_PREFIX = '@kulee/helper';
// 日志输出等级
var LOGGER_LEVEL = Logger.LEVEL.INFO;

var logger = new Logger(LOGGER_PREFIX, LOGGER_LEVEL);

var PM = /*#__PURE__ */ (function () {
    function PM(options) {
        this.listeners = {};
        var target = options.target, _a = options.clazz, clazz = _a === void 0 ? 'default' : _a, _b = options.origin, origin = _b === void 0 ? '*' : _b;
        this.target = target;
        this.clazz = clazz;
        this.origin = origin;
        if (window.addEventListener) {
            window.addEventListener('message', this.handler.bind(this), false);
        }
        else {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window.attachEvent('onmessage', this.handler.bind(this));
        }
    }
    PM.getInstance = function (options) {
        if (!this.instance) {
            this.instance = new PM(options);
        }
        else {
            var target = options.target, _a = options.clazz, clazz = _a === void 0 ? 'default' : _a, _b = options.origin, origin_1 = _b === void 0 ? '*' : _b;
            this.instance.target = target;
            this.instance.clazz = clazz;
            this.instance.origin = origin_1;
        }
        return this.instance;
    };
    PM.prototype.on = function (cmd, handler, scope) {
        var _a;
        if (scope === void 0) { scope = window; }
        var _b = this, listeners = _b.listeners, clazz = _b.clazz;
        listeners[cmd] = listeners[cmd] = [];
        (_a = listeners[cmd]) === null || _a === void 0 ? void 0 : _a.push({
            scope: scope,
            clazz: clazz,
            handler: handler
        });
        return this;
    };
    PM.prototype.emit = function (cmd, data) {
        if (data === void 0) { data = ''; }
        var origin = this.origin;
        logger.log("emit postmessage cmd '".concat(cmd, "', data "), data);
        this.target.postMessage({
            cmd: cmd,
            data: data
        }, origin);
        return this;
    };
    PM.prototype.remove = function (cmd, handler, scope) {
        if (scope === void 0) { scope = window; }
        var exactListeners = this.listeners[cmd];
        if (exactListeners && exactListeners.length > 0) {
            var exactlistenersAfter_1 = [];
            exactListeners.forEach(function (listener) {
                if (listener.scope !== scope || listener.handler !== handler) {
                    exactlistenersAfter_1.push(listener);
                }
            });
            this.listeners[cmd] = exactlistenersAfter_1;
        }
        return this;
    };
    PM.prototype.removeAll = function (cmd) {
        if (cmd) {
            delete this.listeners[cmd];
        }
        else {
            this.listeners = {};
        }
        return this;
    };
    PM.prototype.hasEventListener = function (cmd, handler, scope) {
        if (scope === void 0) { scope = window; }
        var exactListeners = this.listeners[cmd];
        if (!exactListeners) {
            return false;
        }
        var result = false;
        exactListeners.forEach(function (listener) {
            if (listener.scope === scope && listener.handler === handler) {
                result = true;
            }
        });
        return result;
    };
    PM.prototype.handler = function (event) {
        if (!this.isEventAvailable(event)) {
            return;
        }
        var listeners = this.listeners;
        var _a = event.data, cmd = _a.cmd, rest = __rest(_a, ["cmd"]);
        var exactListeners = listeners[cmd];
        if (exactListeners) {
            exactListeners.slice().forEach(function (listener) {
                var scope = listener.scope, handler = listener.handler;
                logger.info("handle event '".concat(cmd, "' call data "), rest);
                handler.call(scope, rest);
            });
        }
    };
    PM.prototype.isEventAvailable = function (event) {
        var _a = event.data, data = _a === void 0 ? {} : _a;
        var cmd = data.cmd, _b = data.clazz, clazz = _b === void 0 ? 'default' : _b;
        return cmd && clazz === this.clazz;
    };
    return PM;
}());

var RandomKey = /*#__PURE__ */ (function () {
    function RandomKey() {
    }
    /**
     * 从随机字符集合中随机获取指定长度字符串
     * @param len 指定字符串长度
     * @returns 随机字符串
     */
    RandomKey.randomFromKeys = function (len) {
        var temp = '';
        for (var i = 0; i < len; i++) {
            temp = "".concat(temp).concat(this.KEYS.charAt(Math.ceil(Math.random() * 100000000) % this.KEYS.length));
        }
        return temp;
    };
    /**
     * 获取随机字符串
     * @param len 指定字符串长度
     * @returns 随机字符串
     */
    RandomKey.run = function (len) {
        if (len === void 0) { len = 18; }
        if (len > 11) {
            var timestamp = new Date().getTime();
            return timestamp + this.randomFromKeys(len - 11);
        }
        else {
            return this.randomFromKeys(len);
        }
    };
    // 可选随机字符集合
    RandomKey.KEYS = '0123456789qwertyuioplkjhgfdsazxcvbnm';
    return RandomKey;
}());
var randomKey = /* #__PURE__ */ RandomKey.run.bind(RandomKey);

var TimeRecord = /*#__PURE__ */ (function () {
    function TimeRecord() {
    }
    /**
     * 添加记录
     * @param key 记录的键值
     */
    TimeRecord.add = function (key, justRecord) {
        if (justRecord === void 0) { justRecord = false; }
        var keyWithPrefix = this.getKey(key);
        var record = LocalStorage.getItem(keyWithPrefix) || {
            time: 0,
            records: []
        };
        var dateNow = Date.now();
        record.time = justRecord ? record.time : dateNow;
        record.records.unshift(dateNow);
        if (record.records.length > 20) {
            record.records.pop();
        }
        LocalStorage.setItem(keyWithPrefix, record);
    };
    /**
     * 移除记录
     * @param key 记录的键值
     */
    TimeRecord.remove = function (key) {
        var keyWithPrefix = this.getKey(key);
        var item = LocalStorage.getItem(keyWithPrefix);
        if (item) {
            LocalStorage.removeItem(keyWithPrefix);
        }
    };
    /**
     * 获取剩余过期秒数
     * @param key 记录的键值
     * @param expireTime 过期时间，单位秒
     * @returns 过期秒数
     */
    TimeRecord.getRestTime = function (key, expireTime) {
        var keyWithPrefix = this.getKey(key);
        var record = LocalStorage.getItem(keyWithPrefix);
        if (record) {
            var time = record.time + expireTime * 1000 - new Date().getTime();
            return time <= 0 ? 0 : Math.ceil(time / 1000);
        }
        else {
            return 0;
        }
    };
    TimeRecord.getTotalRecord = function (key, startTime, endTime) {
        var keyWithPrefix = this.getKey(key);
        var record = LocalStorage.getItem(keyWithPrefix);
        if (record) {
            return record.records.filter(function (item) { return item > startTime && item <= endTime; }).length;
        }
        else {
            return 0;
        }
    };
    /**
     * 键值添加前缀
     * @param key 记录的键值
     * @returns 添加了键值的键值
     */
    TimeRecord.getKey = function (key) {
        return "".concat(this.KEY_PREFIX, "_").concat(key);
    };
    // 键值前缀
    TimeRecord.KEY_PREFIX = '__kulee';
    return TimeRecord;
}());

var URL = /*#__PURE__ */ (function () {
    function URL() {
    }
    /**
     * 获取url参数对象
     * @returns url参数对象
     */
    URL.getUrlQuery = function () {
        var query = window.location.href.split('?')[1];
        var result = {};
        if (query) {
            if (query.indexOf('#') > -1) {
                query = query.split(/\/?#/)[0];
            }
            var queryArr = query.split('&');
            queryArr.forEach(function (param) {
                var pair = param.split('=');
                result[pair[0]] = pair[1];
            });
        }
        return result;
    };
    /**
     * 获取url某个参数值
     * @param name 参数名
     * @returns 参数值
     */
    URL.getUrlQueryByName = function (name) {
        var query = this.getUrlQuery();
        return query[name] || null;
    };
    return URL;
}());

export { CustomError, EventBus, LocalStorage, Logger, PM, TimeRecord, URL, browser, loadScript, randomKey };
//# sourceMappingURL=index.min.js.map
